var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", { staticClass: "xxxxx" }, [
    _c("div", { staticClass: "container" }, [
      _c(
        "ul",
        { staticClass: "menu-list" },
        _vm._l(_vm.data.footer_menu, function (link, label, i) {
          return _c(
            "li",
            { key: i },
            [
              _c(
                "router-link",
                { staticClass: "footer-menu-item1", attrs: { to: link } },
                [_c("span", { domProps: { innerHTML: _vm._s(label) } })]
              ),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "cstm-row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "company-info" }, [
          _c("h2", [_vm._v("(주)선명씨앤피")]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _vm._v(
                "\n                        본사 주소 : " +
                  _vm._s(_vm.data.contact_info?.contact_address) +
                  "\n                        "
              ),
              _c("span", { staticClass: "fs-11 px-2" }, [_vm._v("|")]),
              _vm._v(
                "\n                        대표이사 : " +
                  _vm._s(_vm.data.company_info?.ceo_name) +
                  "\n                    "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n                        사업자번호 : " +
                  _vm._s(_vm.data.company_info?.biz_number) +
                  "\n                        "
              ),
              _c("span", { staticClass: "fs-11 px-2" }, [_vm._v("|")]),
              _vm._v(
                "\n                        통신판매번호 : " +
                  _vm._s(_vm.data.company_info?.online_sales_license_number) +
                  "\n                    "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n                        개인정보관리 책임자 : " +
                  _vm._s(_vm.data.company_info?.privacy_manager) +
                  "\n                        "
              ),
              _c("span", { staticClass: "fs-11 px-2" }, [_vm._v("|")]),
              _vm._v(
                "\n                        이메일 : " +
                  _vm._s(_vm.data.contact_info?.contact_email) +
                  "\n                    "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "\n                        연락처 : " +
                  _vm._s(_vm.data.contact_info?.contact_phone) +
                  "\n                        "
              ),
              _c("span", { staticClass: "fs-11 px-2" }, [_vm._v("|")]),
              _vm._v(
                "\n                        팩스 : " +
                  _vm._s(_vm.data.contact_info?.contact_fax) +
                  "\n                    "
              ),
            ]),
            _vm._v(" "),
            _c("li", [
              _vm._v(
                "웹하드 : " +
                  _vm._s(_vm.data.company_info?.webhard_id) +
                  " / " +
                  _vm._s(_vm.data.company_info?.webhard_pw)
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("small", {
            domProps: { innerHTML: _vm._s(_vm.data.copyright_text) },
          }),
        ]),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _vm._m(2),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", [
      _c("img", {
        attrs: { src: "/assets/img/footer/footer_logo.svg", alt: "로고" },
      }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "address-list" }, [
      _c("li", [
        _c("strong", [_vm._v("서울본점(Offset Factory)")]),
        _vm._v(" "),
        _c("address", [
          _vm._v(
            "(04555) 서울특별시 중구 충무로 29 아시아미디어타워 301호, 301-1호"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("파주지점(Digital Factory)")]),
        _vm._v(" "),
        _c("address", [_vm._v("(10881) 경기도 파주시 광인사길 223")]),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("i", [_vm._v("프리원 공식 채널 +")]),
        _vm._v(" "),
        _c("ul", [
          _c("li", [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.instagram.com/prione_official",
                  target: "_blank",
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: "/assets/img/footer/insta-icon.svg",
                    alt: "인스타그램",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.youtube.com/@iprione",
                  target: "_blank",
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: "/assets/img/footer/youtube-icon.svg",
                    alt: "유튜브",
                  },
                }),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                attrs: {
                  href: "https://pf.kakao.com/_lmexjX",
                  target: "_blank",
                },
              },
              [
                _c("img", {
                  attrs: {
                    src: "/assets/img/footer/kakao-icon.svg",
                    alt: "카카오채널",
                  },
                }),
              ]
            ),
          ]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "cstm-select1" }, [
      _c("input", { attrs: { value: "Family Site", readonly: "" } }),
      _vm._v(" "),
      _c("img", {
        staticClass: "arrow",
        attrs: { src: "/assets/img/footer/down-arrow.svg" },
      }),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("ul", [
        _c("li", [
          _c(
            "a",
            { attrs: { href: "https://www.nemolab.co.kr/", target: "_blank" } },
            [
              _vm._v(
                "\n                            네모연구소\n                            "
              ),
              _c("img", {
                attrs: {
                  src: "/assets/img/footer/share-icon.svg",
                  alt: "페이지 이동",
                },
              }),
            ]
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }